import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface CollapsableToggleItemPanelI {
    open: boolean;
    className?: string;
    children?: ReactNode | string;
    testId?: string;
}

const CollapsableToggleItemPanel: FC<CollapsableToggleItemPanelI> = ({ open, className, children, testId }) => {
    return (
        <div
            className={twMerge(
                'w-full flex flex-col transition-all overflow-hidden bg-white border-t border-gray-50',
                !open && 'hidden',
                className,
            )}
            data-test-id={`collapsable-panel-${testId}`}
        >
            {children}
        </div>
    );
};

export default CollapsableToggleItemPanel;
